<template>
  <el-checkbox-group class="image-format-checkbox-group" v-bind="$attrs" v-model="checkedValue" @change="handleChange">
    <el-checkbox v-for="item in checkboxOptions" :label="item.value" :disabled="item.disabled" :key="item.value">{{ item.label
      }}</el-checkbox>

  </el-checkbox-group>
</template>

<script>
export default {
    components: {},
    props: {
        value: {
            type: String,
            default: 'visable',
        },
        options: {
            type: Array,
            default: () => ['visable', 'ir'],
        },
    },

    data() {
        return {
            checkedValue: [],
        };
    },
    computed: {
        checkboxOptions() {
            let options = [
                {
                    // 存储广角镜头照片
                    label: this.$t('route.waypoint.wideImg'),
                    value: 'wide',
                    hidden: true,
                },
                {
                    // 存储可见光镜头照片
                    label: this.$t('route.waypoint.visableImg'),
                    value: 'visable',
                    hidden: false,
                },

                {
                    // 存储红外镜头照片
                    label: this.$t('route.waypoint.irImg'),
                    value: 'ir',
                    hidden: false,
                },
                // {
                //   // 存储变焦镜头照片
                //   label: this.$t('route.waypoint.zoomImg'),
                //   value: 'zoom',
                //   hidden: true
                // },
                // {
                //   // 存储窄带镜头拍摄照片
                //   label: this.$t('route.waypoint.narrowBandImg'),
                //   value: 'narrow_band',
                //   hidden: true
                // }
            ];
            let list = options.filter((item) => item.hidden !== true && this.options.includes(item.value));
            if (list.length === 1) {
                list[0].disabled = true;
            } else if (list.length > 1) {
                list.forEach((item) => {
                    item.disabled = false;
                });
            }

            return list;
        },
    },
    methods: {
        handleChange() {
            this.$emit('input', this.checkedValue.join(','));
        },
        initCheckboxValue() {
            if (this.value) {
                this.checkedValue = this.value.split(',');
            }
        },
    },
    mounted() {
        this.initCheckboxValue();
    },
    watch: {
        value(newVal) {
            this.initCheckboxValue();
        },
    },
};
</script>

<style lang="scss" scoped>
.image-format-checkbox-group {
  ::v-deep .el-checkbox {
    margin-right: 10px;

    &__label {
      padding-left: 6px;
    }

    &__input.is-checked+.el-checkbox__label {
      color: #409EFF !important;
    }

    &__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #409EFF !important;
      border-color: #409EFF !important;
    }
  }
}
</style>
